import { useCallback, useEffect, useState } from 'react'
import { createContainer } from 'unstated-next'

interface useGlassSystemProps {
  x: number
  y: number
}

type MousePositionEvent = MouseEvent | TouchEvent

function useGlassSystem(): useGlassSystemProps {
  const [x, setX] = useState(0)
  const [y, setY] = useState(0)

  const handleMousePosition = useCallback(
    (e: MousePositionEvent) => {
      const ee = e as any
      let x: number
      let y: number
      if (ee.touches) {
        x = ee.touches[0].clientX
        y = ee.touches[0].clientY
      } else {
        x = ee.clientX
        y = ee.clientY
      }
      setX(x)
      setY(y)
    },
    [setX, setY]
  )

  useEffect(() => {
    window.addEventListener('mousemove', handleMousePosition, { passive: true })
    window.addEventListener('touchmove', handleMousePosition, { passive: true })
    return () => {
      window.removeEventListener('mousemove', handleMousePosition)
      window.removeEventListener('touchmove', handleMousePosition)
    }
  }, [handleMousePosition])

  return {
    x,
    y,
  }
}

const GlassSystem = createContainer(useGlassSystem)

export default GlassSystem
